import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { NotificationsComponent } from './notifications/notifications.component';

export const notificationRoutes: Routes = [{ path: 'notifications', component: NotificationsComponent}];

@NgModule({})
export class NotificationsRoutingModule { }
